module.exports = __webpack_public_path__ + "static/media/puzzles.f5922071.gif";